"use strict";
/* ========================================================================
    Module: Link to phone
 ========================================================================== */
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkToPhone = void 0;
/**
 * 電話番号にリンクを設定する
 *
 * @returns void
 */
const linkToPhone = () => {
    const ua = navigator.userAgent.toLowerCase();
    const elements = document.querySelectorAll("[data-link-to-phone]");
    if (!ua.match(/iphone|android.+mobile/)) {
        return;
    }
    if (elements.length <= 0) {
        return;
    }
    elements.forEach((element) => {
        const phoneNumber = element.dataset.linkToPhone?.replace(/-/g, "");
        const anchor = document.createElement("a");
        anchor.setAttribute("href", `tel:${phoneNumber}`);
        element.before(anchor);
        anchor.append(element);
    });
};
exports.linkToPhone = linkToPhone;
